import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Focusable } from '../Focusable';
import { Icon } from '../Icon';
import { Text } from '../Text';
export const Feedback = ({ onClick, disabled, style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Focusable, { style: [styles.container, style], hoverStyle: styles.hover, onPress: onClick, disabled: disabled },
        React.createElement(View, { style: styles.personIconWrapper },
            React.createElement(Icon, { name: 'person-feedback', color: (color) => color.white.p100, filled: true })),
        React.createElement(View, null,
            React.createElement(Text, { type: 'headline', size: 'lg', style: styles.title }, "How can we improve?"),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.subTitle }, "Share your suggestion or feedback"),
            React.createElement(View, { style: styles.leaveFeedbackWrapper },
                React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.leaveFeedback }, "Leave Feedback"),
                React.createElement(Icon, { name: 'chevron-right', size: 21, color: (color) => color.primary.solid })))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: size.G - 1,
        borderRadius: size.G,
        borderWidth: 1,
        borderColor: color.invert2.p4
    },
    hover: { backgroundColor: color.invert2.p10 },
    personIconWrapper: {
        height: 55,
        width: 55,
        borderRadius: 9999,
        backgroundColor: color.primary.solid,
        marginRight: size.C,
        alignItems: 'center',
        justifyContent: 'center'
    },
    personIcon: { color: color.white.p100 },
    title: { color: color.invert2.p100 },
    subTitle: { color: color.invert2.p56, marginTop: size.B },
    leaveFeedbackWrapper: {
        marginTop: size.F,
        flexDirection: 'row',
        alignItems: 'center'
    },
    leaveFeedback: {
        fontWeight: '600',
        fontSize: size.F,
        lineHeight: size.H,
        letterSpacing: -0.01,
        color: color.primary.solid,
        marginRight: size.B
    }
}));
//# sourceMappingURL=index.js.map